module.exports = __webpack_public_path__ + "dist/media/logo--sl.95ecc58e.svg";